import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Réserve une route à ROLE_SUPER_ADMIN — l'administration technique du produit (affichage des
 * blocs, journal de version). À chaîner APRÈS authGuard et adminGuard.
 *
 * ⚠️ Masquer l'entrée de menu ne suffit PAS, il faut aussi garder la route : leçon payée sur
 * « Catégories du Mix », où l'onglet était caché mais où l'URL directe rouvrait l'écran.
 * Le back reste l'autorité de toute façon (403), ceci évite juste d'afficher un écran vide.
 */
export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isSuperAdmin() ? true : router.createUrlTree(['/admin']);
};
